import {
  AlarmClock,
  Anchor,
  Archive,
  Aperture,
  Badge,
  BadgeAlert,
  BadgeCheck,
  BadgeDollarSign,
  Ban,
  Bell,
  Beer,
  Bomb,
  BookOpen,
  Bookmark,
  Bot,
  Box,
  Boxes,
  Brain,
  Briefcase,
  Brush,
  BrushCleaning,
  Cable,
  Camera,
  Candy,
  Carrot,
  Castle,
  CircleDollarSign,
  CircleAlert,
  CircleCheck,
  CirclePlay,
  CircleStop,
  Clapperboard,
  Clock,
  Cloud,
  CloudLightning,
  CloudRain,
  Coins,
  Code,
  Compass,
  Cog,
  Coffee,
  Command,
  Cpu,
  Crosshair,
  Crown,
  CupSoda,
  Dice6,
  Dices,
  Disc3,
  Download,
  Drama,
  Drum,
  Droplets,
  Eraser,
  Eye,
  EyeOff,
  FastForward,
  Film,
  Flag,
  Flame,
  Footprints,
  Gamepad2,
  Gauge,
  Gem,
  Gift,
  GlassWater,
  Glasses,
  Hammer,
  HandCoins,
  HandHeart,
  Headphones,
  Heart,
  Hourglass,
  Image,
  Images,
  Joystick,
  Key,
  Landmark,
  Laugh,
  Layers,
  Lightbulb,
  LoaderCircle,
  Lock,
  LockOpen,
  Map,
  Martini,
  Medal,
  Megaphone,
  Milk,
  MessageCircle,
  Mic,
  MonitorPlay,
  MousePointerBan,
  Music,
  Music2,
  Package,
  PackageOpen,
  Palette,
  PaintBucket,
  PartyPopper,
  PersonStanding,
  Plane,
  Projector,
  Rabbit,
  QrCode,
  Radar,
  Radio,
  Rocket,
  Scan,
  ScanEye,
  ScanFace,
  ScanLine,
  Scroll,
  ShowerHead,
  Shield,
  ShieldAlert,
  ShieldBan,
  SlidersHorizontal,
  Smile,
  SprayCan,
  Sparkles,
  SquarePlay,
  Star,
  Syringe,
  Swords,
  Target,
  Ticket,
  Timer,
  Trophy,
  Tv,
  Upload,
  UserCog,
  Webhook,
  Video,
  Volume2,
  WandSparkles,
  Waves,
  Wine,
  Zap,
} from "lucide-react";

export const CURRENCY_ORDER = ["free_currency", "paid_currency", "giveaway_currency", "event_currency"];

const DEFAULT_CURRENCY_NAMES = {
  free: "Bunny Tokens",
  paid: "Rat Coins",
  free_currency: "Bunny Tokens",
  paid_currency: "Rat Coins",
  giveaway_currency: "Giveaway Tokens",
  event_currency: "Event Tokens",
};

const RAW_ICON_OPTIONS = [
  ["Carrot", "Carrot", Carrot],
  ["Coins", "Coins", Coins],
  ["Ticket", "Ticket", Ticket],
  ["Sparkles", "Sparkles", Sparkles],
  ["BadgeAlert", "Alert Badge", BadgeAlert],
  ["BadgeCheck", "Verified Badge", BadgeCheck],
  ["Ban", "Blocked", Ban],
  ["CircleAlert", "Alert Circle", CircleAlert],
  ["CircleCheck", "Check Circle", CircleCheck],
  ["CircleDollarSign", "Dollar", CircleDollarSign],
  ["CirclePlay", "Play Circle", CirclePlay],
  ["CircleStop", "Stop Circle", CircleStop],
  ["Gift", "Gift", Gift],
  ["Gem", "Gem", Gem],
  ["Star", "Star", Star],
  ["Zap", "Zap", Zap],
  ["BadgeDollarSign", "Paid", BadgeDollarSign],
  ["HandCoins", "Hand Coins", HandCoins],
  ["Landmark", "Bank", Landmark],
  ["Trophy", "Trophy", Trophy],
  ["Medal", "Medal", Medal],
  ["Crown", "Crown", Crown],
  ["Badge", "Badge", Badge],
  ["Eye", "Eye", Eye],
  ["EyeOff", "Hidden Eye", EyeOff],
  ["ScanEye", "Glowing Eyes", ScanEye],
  ["Glasses", "Glasses", Glasses],
  ["Projector", "Hologram", Projector],
  ["Scan", "Scan", Scan],
  ["ScanLine", "Scan Line", ScanLine],
  ["ScanFace", "Face Scan", ScanFace],
  ["Box", "Box", Box],
  ["Boxes", "Boxes", Boxes],
  ["BookOpen", "Open Book", BookOpen],
  ["Bookmark", "Bookmark", Bookmark],
  ["PartyPopper", "Party", PartyPopper],
  ["PersonStanding", "Dancer", PersonStanding],
  ["Footprints", "Footprints", Footprints],
  ["Music2", "Dance Music", Music2],
  ["Heart", "Heart", Heart],
  ["Smile", "Smile", Smile],
  ["Laugh", "Laugh", Laugh],
  ["Drama", "Drama", Drama],
  ["Swords", "Swords", Swords],
  ["Shield", "Shield", Shield],
  ["ShieldAlert", "Shield Alert", ShieldAlert],
  ["Target", "Target", Target],
  ["Crosshair", "Crosshair", Crosshair],
  ["MousePointerBan", "Blocked Cursor", MousePointerBan],
  ["Flag", "Flag", Flag],
  ["Map", "Map", Map],
  ["Compass", "Compass", Compass],
  ["Radar", "Radar", Radar],
  ["QrCode", "QR Code", QrCode],
  ["Anchor", "Anchor", Anchor],
  ["Castle", "Castle", Castle],
  ["Hammer", "Hammer", Hammer],
  ["Key", "Key", Key],
  ["Scroll", "Scroll", Scroll],
  ["Archive", "Archive", Archive],
  ["Package", "Package", Package],
  ["PackageOpen", "Open Package", PackageOpen],
  ["Upload", "Upload", Upload],
  ["Download", "Download", Download],
  ["Dice6", "Die", Dice6],
  ["Dices", "Dice", Dices],
  ["Gamepad2", "Gamepad", Gamepad2],
  ["Joystick", "Joystick", Joystick],
  ["Music", "Music", Music],
  ["Headphones", "Headphones", Headphones],
  ["Mic", "Mic", Mic],
  ["Volume2", "Volume", Volume2],
  ["Radio", "Radio", Radio],
  ["Drum", "Drum", Drum],
  ["Disc3", "Disc", Disc3],
  ["Video", "Video", Video],
  ["Film", "Film", Film],
  ["Clapperboard", "Clapperboard", Clapperboard],
  ["Camera", "Camera", Camera],
  ["Aperture", "Aperture", Aperture],
  ["Image", "Image", Image],
  ["Images", "Images", Images],
  ["Tv", "TV", Tv],
  ["MonitorPlay", "Monitor Play", MonitorPlay],
  ["SquarePlay", "Play Square", SquarePlay],
  ["FastForward", "Fast Forward", FastForward],
  ["Megaphone", "Megaphone", Megaphone],
  ["Bell", "Bell", Bell],
  ["MessageCircle", "Message", MessageCircle],
  ["Bot", "Bot", Bot],
  ["Brain", "Brain", Brain],
  ["Cpu", "CPU", Cpu],
  ["Code", "Code", Code],
  ["Cog", "Cog", Cog],
  ["Command", "Command", Command],
  ["Cable", "Cable", Cable],
  ["Webhook", "Webhook", Webhook],
  ["SlidersHorizontal", "Sliders", SlidersHorizontal],
  ["Layers", "Layers", Layers],
  ["Gauge", "Gauge", Gauge],
  ["LoaderCircle", "Loader", LoaderCircle],
  ["Lock", "Lock", Lock],
  ["LockOpen", "Unlock", LockOpen],
  ["UserCog", "User Settings", UserCog],
  ["Rocket", "Rocket", Rocket],
  ["Bomb", "Bomb", Bomb],
  ["Flame", "Flame", Flame],
  ["CloudLightning", "Lightning", CloudLightning],
  ["WandSparkles", "Magic Wand", WandSparkles],
  ["Lightbulb", "Idea", Lightbulb],
  ["AlarmClock", "Alarm Clock", AlarmClock],
  ["Clock", "Clock", Clock],
  ["Hourglass", "Hourglass", Hourglass],
  ["Timer", "Timer", Timer],
  ["Palette", "Palette", Palette],
  ["PaintBucket", "Paint Bucket", PaintBucket],
  ["Brush", "Brush", Brush],
  ["BrushCleaning", "Cleaning Brush", BrushCleaning],
  ["Droplets", "Splash", Droplets],
  ["Waves", "Waves", Waves],
  ["CloudRain", "Spray", CloudRain],
  ["Cloud", "Cloud", Cloud],
  ["SprayCan", "Spray Bottle", SprayCan],
  ["ShowerHead", "Shower", ShowerHead],
  ["Syringe", "Syringe", Syringe],
  ["Eraser", "Eraser", Eraser],
  ["HandHeart", "Hand Heart", HandHeart],
  ["Beer", "Beer", Beer],
  ["Martini", "Martini", Martini],
  ["Wine", "Wine", Wine],
  ["Coffee", "Coffee", Coffee],
  ["GlassWater", "Glass Water", GlassWater],
  ["CupSoda", "Soda", CupSoda],
  ["Milk", "Milk", Milk],
  ["Candy", "Candy", Candy],
  ["Plane", "Plane", Plane],
  ["Briefcase", "Briefcase", Briefcase],
  ["Rabbit", "Rabbit", Rabbit],
];

export const ICON_OPTIONS = RAW_ICON_OPTIONS.filter((option) => {
  const [id, label, Icon] = Array.isArray(option) ? option : [];
  return Boolean(id && label && isRenderableIcon(Icon));
});

const FALLBACK_ICON = isRenderableIcon(Coins) ? Coins : () => null;
const ICON_MAP = Object.fromEntries(ICON_OPTIONS.map(([id, , Icon]) => [id, Icon]));

export function currencyLabel(currency) {
  if (currency?.name) return currency.name;
  const raw = currency?.kind || currency?.id || "Currency";
  if (DEFAULT_CURRENCY_NAMES[raw]) return DEFAULT_CURRENCY_NAMES[raw];
  return raw.replace(/_/g, " ").replace(/\b\w/g, (m) => m.toUpperCase());
}

export function currencyAmountLabel(amount, currency) {
  return `${Number(amount || 0)} ${currencyLabel(currency)}`;
}

export function sortCurrencies(currencies = []) {
  return [...currencies].sort((a, b) => {
    const ai = CURRENCY_ORDER.indexOf(a.id);
    const bi = CURRENCY_ORDER.indexOf(b.id);
    return (ai === -1 ? 99 : ai) - (bi === -1 ? 99 : bi);
  });
}

export function visibleCurrencies(currencies = []) {
  return sortCurrencies(currencies.filter((c) => c.enabled !== false && (c.visible !== false || c.id === "giveaway_currency")));
}

export function CurrencyIcon({ currency, className = "w-4 h-4" }) {
  const MaybeIcon = ICON_MAP[currency?.icon];
  const Icon = isRenderableIcon(MaybeIcon) ? MaybeIcon : FALLBACK_ICON;
  return <Icon className={className} style={{ color: currency?.color }} />;
}

function isRenderableIcon(Icon) {
  return typeof Icon === "function" || (Icon && typeof Icon === "object");
}
